import { helper } from '@ember/component/helper';

export default helper(function jsonParse([stringifiedJSON] /*, named*/) {
  if (!stringifiedJSON) return {};
  let json = '';
  try {
    json = JSON.parse(stringifiedJSON);
  } catch (err) {
    console.debug(err);
  }
  return json;
});
